import { takeLatest, takeEvery, select, call } from 'redux-saga/effects';
import * as cnt from './constants';
import { apiSaga } from '../../../sagas';
import {admin as adminApis, assetLanding as assetLandingApis} from '../../../api';
import { delay } from "redux-saga";

function* consolidate() {
  const { email, associateEmail } = yield select(state => state.assetsConsolidation);
  const { companyId } = yield select(state => state.user.toJS().company);
  yield* apiSaga(cnt.CONSOLIDATE_ASSETS, adminApis.consolidateAccount, [email, companyId, associateEmail]);
}

function* getAssets() {
  yield* apiSaga(cnt.GET_ASSETS, assetLandingApis.getAssets, []);
}

function* processHashtoken({ type, payload }) {
  const { hashToken } = payload;
  yield* apiSaga(cnt.PROCESS_HASHTOKEN, assetLandingApis.verifyToken, [hashToken]);
  yield call(delay, 300);
  yield* getAssets();
}

export default [
  takeLatest(cnt.PROCESS_HASHTOKEN, processHashtoken),
  takeLatest(`${cnt.GET_ASSETS}_SUCCESS`, consolidate),
];



// WEBPACK FOOTER //
// ./src/app/components/assets-consolidation/__storeFiles__/sagas.js